export const caseCV = (offset) => {
  var caseCV = {
    dots: false,
    infinite: false,
    speed: 250,
    arrows: true,
    vertical: false,
    slidesToShow: 15,
    slidesToScroll: 15,
    initialSlide: offset,
    /* eslint-disable*/
    responsive: [
      {
        breakpoint: 1234,
        settings: {
          slidesToShow: 10,
          slidesToScroll: 10,
          infinite: false,
          dots: false,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 8,
          slidesToScroll: 8,
          infinite: false,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5,
          initialSlide: offset,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
          initialSlide: offset,
        },
      },
    ],
  };
  return caseCV;
};



// WEBPACK FOOTER //
// ./src/common/cbttopnavigationsettings.js